
import _ from 'lodash'

export default {
    props: {
        initialQuery: {
            type: String,
            default: ''
        },
        value: {
            type: [String, Number],
            default: null,
        },
        minQuery: {
            type: Number,
            default: 2,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: 'Space Force',
        },
        btnLabel: {
            type: String,
            default: 'Find & Verify Group'
        },
        helpText: {
            type: String,
            default: null,
        },
        nonParticipatingAlert: {
            type: Boolean,
            default: true
        },
        levels: {
            type: Array,
            default: () => ['paying', 'financial_advisor', 'dpc']
        }
    },
    data () {
        return {
            query: '',
            error: null,
            groupValue: null,
        }
    },
    async fetch () {
        this.error = null
        this.groupValue = null
        if (this.minQuery && this.query.length < this.minQuery) {
            return
        }
        this.loading = true
        const data = await this.$try('findGroup', { query: this.query }, { alert: false, spinner: false })
        this.loading = false
        if (data.error) {
            this.error = data.error
            this.groupValue = null
        } else if (data && (this.levels || []).every(level => !data[level]) && this.nonParticipatingAlert) {
            this.error = 'We\'re sorry - it looks like this group does not participate in our program. Please check your spelling or reach out to our team at <a href="mailto:help@doctorschoiceusa.com">help@doctorschoiceusa.com</a> if you think this may be an error.'
            this.groupValue = null
        } else {
            this.error = null
            this.groupValue = data || null
        }
    },
    computed: {},
    watch: {
        value () {
            if (!_.isEqual(parseInt(this.value), this.groupValue?.id)) {
                this.updateValue()
            }
        },
        groupValue () {
            this.emitInput()
        },
        query (q) {
            return this.onQuery(q)
        }
    },
    mounted () {
        this.query = this.initialQuery || ''
        this.$fetch()
        this.updateValue()
    },
    methods: {
        async updateValue () {
            if (this.value) {
                const group = await this.$api.getGroup(this.value)
                this.groupValue = group
            } else {
                this.groupValue = null
            }
        },
        emitInput () {
            this.$emit('input', this.groupValue?.id || null)
            this.$emit('input-raw', this.groupValue || null)
        },
        onQuery (query) {
            if (!query) {
                this.groupValue = null
                this.error = null
            }
            this.query = query
            this.$emit('input-query', this.query)
        },
    },
}
